// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"DialogHeader_subtitle__3GSJ3","title":"DialogHeader_title__1ioTP","header":"DialogHeader_header__1Jnms"};